/**
 * Shared "Mein Fahrzeug" store: persists the selected vehicle in localStorage,
 * renders [data-my-vehicle] bars and [data-fitment-check] boxes.
 * Fitment is only "confirmed" when brand, model and year exactly match product metafields.
 */
(function (global) {
  if (global.FusmattenVehicle) return;

  var KEY = 'fusmatten-vehicle';
  var LEGACY_KEY = 'fusmatten-vf-selection';
  var EVENT = 'fusmatten:vehicle';

  function clean(v) { return String(v == null ? '' : v).trim(); }

  function normalize(value) {
    return clean(value).toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function read() {
    var data = null;
    try { data = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!data) {
      try { data = JSON.parse(sessionStorage.getItem(LEGACY_KEY) || 'null'); } catch (e) {}
    }
    if (!data || !clean(data.brand)) return null;
    return { brand: clean(data.brand), model: clean(data.model), year: clean(data.year) };
  }

  function emit(vehicle) {
    document.dispatchEvent(new CustomEvent(EVENT, { detail: { vehicle: vehicle } }));
  }

  function track(name, params) {
    if (typeof global.gtag === 'function') global.gtag('event', name, params || {});
  }

  function set(vehicle) {
    var next = { brand: clean(vehicle && vehicle.brand), model: clean(vehicle && vehicle.model), year: clean(vehicle && vehicle.year) };
    if (!next.brand) return clear();
    var prev = read();
    try { localStorage.setItem(KEY, JSON.stringify(next)); } catch (e) {}
    try { sessionStorage.setItem(LEGACY_KEY, JSON.stringify(next)); } catch (e) {}
    if (!prev || prev.brand !== next.brand || prev.model !== next.model || prev.year !== next.year) {
      if (next.model && next.year) track('vehicle_selected', { vehicle_brand: next.brand, vehicle_model: next.model, vehicle_year: next.year });
      emit(next);
    }
    return next;
  }

  function clear() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    try { sessionStorage.removeItem(LEGACY_KEY); } catch (e) {}
    emit(null);
    return null;
  }

  function label(vehicle) {
    if (!vehicle) return '';
    // Model values usually repeat the brand ("Ford EcoSport"); show the brand only once.
    var model = clean(vehicle.model);
    var brand = clean(vehicle.brand);
    var brandWords = normalize(brand).split(' ').length;
    var modelHead = normalize(model).split(' ').slice(0, brandWords).join(' ');
    var parts = model && modelHead === normalize(brand) ? model : [brand, model].filter(Boolean).join(' ');
    parts = parts.replace(/(^|\s)(\S+)(\s+\2)+(?=\s|$)/gi, '$1$2');
    return vehicle.year ? parts + ' · ' + vehicle.year : parts;
  }

  function openSelector() {
    document.documentElement.classList.add('vf-editing');
    // Prefer a selector that is actually visible (brand pages hide the header one and show their own).
    var select = Array.prototype.find.call(
      document.querySelectorAll('[data-vehicle-filter] select[data-vf-brand]'),
      function (s) { return s.offsetParent !== null; }
    ) || null;
    if (!select || !select.closest('.header-search')) document.documentElement.classList.remove('vf-editing');
    track('vehicle_selector_open', {});
    if (!select) {
      global.location.href = (global.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      return;
    }
    var box = select.closest('[data-vehicle-filter]') || select;
    box.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
    select.focus({ preventScroll: true });
  }

  /* ---------- Results link ---------- */

  var brandDirectory = null;
  function loadBrandDirectory() {
    if (brandDirectory) return brandDirectory;
    var url = global.__FUSMATTEN_BRANDS_URL__;
    brandDirectory = !url ? Promise.resolve({}) : fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (list) {
        var map = {};
        (list || []).forEach(function (e) {
          if (!e || !e.collection) return;
          if (e.name) map[normalize(e.name)] = e.collection;
          if (e.slug) map[normalize(e.slug)] = e.collection;
        });
        return map;
      })
      .catch(function () { return {}; });
    return brandDirectory;
  }

  function resultsUrl(vehicle, directory) {
    var root = (global.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var handle = directory && directory[normalize(vehicle.brand)];
    var params = new URLSearchParams();
    if (!handle) params.append('filter.p.m.custom.marke', vehicle.brand);
    if (vehicle.model) params.append('filter.p.m.custom.fahrzeugmodell', vehicle.model);
    if (vehicle.year) params.append('filter.p.m.custom.Baujahr', vehicle.year);
    var base = root + 'collections/' + (handle ? encodeURIComponent(handle) : 'all');
    var qs = params.toString();
    return qs ? base + '?' + qs : base;
  }

  function renderResultLinks(vehicle) {
    var links = document.querySelectorAll('[data-my-vehicle-results]');
    if (!links.length || !vehicle) return;
    links.forEach(function (a) { a.href = resultsUrl(vehicle, null); });
    loadBrandDirectory().then(function (dir) {
      links.forEach(function (a) { a.href = resultsUrl(vehicle, dir); });
    });
  }

  /* ---------- Mein Fahrzeug bar ---------- */

  function renderBars(vehicle) {
    document.documentElement.classList.toggle('has-vehicle', !!(vehicle && vehicle.model && vehicle.year));
    document.querySelectorAll('[data-my-vehicle]').forEach(function (bar) {
      var text = bar.querySelector('[data-my-vehicle-label]');
      bar.hidden = !vehicle;
      if (text) text.textContent = label(vehicle);
    });
  }

  function bindBars() {
    document.addEventListener('click', function (event) {
      var cancel = event.target.closest('[data-vf-cancel]');
      if (cancel) {
        event.preventDefault();
        document.documentElement.classList.remove('vf-editing');
        var changeBtn = Array.prototype.find.call(
          document.querySelectorAll('.header-vehicle-filter-bar [data-my-vehicle-change]'),
          function (el) { return el.offsetParent !== null; }
        );
        if (changeBtn) changeBtn.focus();
        return;
      }
      var change = event.target.closest('[data-my-vehicle-change]');
      if (change) { event.preventDefault(); openSelector(); return; }
      var remove = event.target.closest('[data-my-vehicle-clear]');
      if (remove) {
        event.preventDefault();
        clear();
        document.querySelectorAll('[data-vehicle-filter] select').forEach(function (s) {
          s.value = '';
          if (!s.hasAttribute('data-vf-brand')) s.disabled = true;
        });
      }
    });
  }

  /* ---------- Fitment check ---------- */

  function splitList(raw) {
    var value = clean(raw);
    if (!value) return [];
    try {
      var parsed = JSON.parse(value);
      if (Array.isArray(parsed)) return parsed.map(clean).filter(Boolean);
      if (typeof parsed === 'string') value = parsed;
    } catch (e) {}
    return value.split(/\s*(?:\|\|\||,|;)\s*/).map(clean).filter(Boolean);
  }

  function listHas(list, wanted) {
    var w = normalize(wanted);
    return list.some(function (item) { return normalize(item) === w; });
  }

  function listLoosely(list, wanted) {
    var w = ' ' + normalize(wanted) + ' ';
    return list.some(function (item) {
      var n = ' ' + normalize(item) + ' ';
      return n.indexOf(w) !== -1 || w.indexOf(n) !== -1;
    });
  }

  function yearMatches(list, year) {
    var y = parseInt(year, 10);
    if (!Number.isFinite(y)) return listHas(list, year);
    return list.some(function (entry) {
      var range = String(entry).match(/(\d{4})\s*[-–]\s*(\d{4}|heute|today)?/i);
      if (range) {
        var from = parseInt(range[1], 10);
        var to = range[2] && /^\d{4}$/.test(range[2]) ? parseInt(range[2], 10) : 9999;
        return y >= from && y <= to;
      }
      return parseInt(entry, 10) === y;
    });
  }

  /** @returns {'none'|'confirmed'|'check'|'mismatch'} */
  function fitmentStatus(product, vehicle) {
    if (!vehicle || !vehicle.model || !vehicle.year) return 'none';
    if (!product.brands.length || !product.models.length) return 'check';
    if (!listHas(product.brands, vehicle.brand) && !listLoosely(product.brands, vehicle.brand)) return 'mismatch';
    var exactModel = listHas(product.models, vehicle.model);
    if (!exactModel && !listLoosely(product.models, vehicle.model)) return 'mismatch';
    if (!product.years.length) return 'check';
    if (!yearMatches(product.years, vehicle.year)) return 'mismatch';
    if (!exactModel || !listHas(product.brands, vehicle.brand)) return 'check';
    if (product.generation && isBoundaryYear(product.years, vehicle.year)) return 'generation';
    return 'confirmed';
  }

  // Generations overlap in their first/last production year, so model + year alone is ambiguous there.
  // A last year that is the current year or later means the model is still in production, not a changeover.
  function isBoundaryYear(list, year) {
    var y = parseInt(year, 10);
    var nums = list.map(function (v) { return parseInt(v, 10); }).filter(Number.isFinite);
    if (!Number.isFinite(y) || !nums.length) return false;
    var first = Math.min.apply(null, nums);
    var last = Math.max.apply(null, nums);
    var stillProduced = last >= new Date().getFullYear();
    return y === first || (y === last && !stillProduced);
  }

  var STATUS_COPY = {
    none: { title: 'Bitte Fahrzeug auswählen', text: 'Wählen Sie Marke, Modell und Baujahr, um die Passform zu prüfen.', action: 'Fahrzeug auswählen' },
    confirmed: { title: 'Passform bestätigt', text: 'Laut unseren Fahrzeugdaten passt dieses Produkt zu Ihrem Fahrzeug.', action: 'Ändern' },
    generation: { title: 'Fahrzeugvariante prüfen', text: 'Ihr Baujahr liegt im Übergang zwischen zwei Baureihen. Dieses Produkt passt für die Baureihe {gen}. Bitte prüfen Sie Ihren Fahrzeugschein.', action: 'Ändern' },
    check: { title: 'Fahrzeugvariante prüfen', text: 'Bitte vergleichen Sie Baureihe und Baujahr in der Produktbeschreibung mit Ihrem Fahrzeug.', action: 'Ändern' },
    mismatch: { title: 'Nicht passend für Ihr Fahrzeug', text: 'Laut unseren Fahrzeugdaten ist dieses Produkt für ein anderes Fahrzeug vorgesehen.', action: 'Ändern' }
  };

  function renderFitment(vehicle) {
    document.querySelectorAll('[data-fitment-check]').forEach(function (box) {
      var product = {
        brands: splitList(box.getAttribute('data-brands')),
        models: splitList(box.getAttribute('data-models')),
        years: splitList(box.getAttribute('data-years')),
        generation: clean(box.getAttribute('data-generation'))
      };
      var status = fitmentStatus(product, vehicle);
      var copy = STATUS_COPY[status];
      box.setAttribute('data-status', status);
      var vehicleEl = box.querySelector('[data-fitment-vehicle]');
      var titleEl = box.querySelector('[data-fitment-title]');
      var textEl = box.querySelector('[data-fitment-text]');
      var actionEl = box.querySelector('[data-my-vehicle-change]');
      if (vehicleEl) { vehicleEl.textContent = label(vehicle); vehicleEl.hidden = !vehicle; }
      if (titleEl) titleEl.textContent = copy.title;
      if (textEl) {
        var generation = product.generation;
        textEl.textContent = copy.text.replace('{gen}', generation) + (status === 'confirmed' && generation ? ' Baureihe: ' + generation + '.' : '');
      }
      if (actionEl) actionEl.textContent = copy.action;
      var resultsEl = box.querySelector('[data-my-vehicle-results]');
      if (resultsEl) resultsEl.hidden = status !== 'mismatch';
      if (status === 'confirmed' && box.getAttribute('data-tracked') !== label(vehicle)) {
        box.setAttribute('data-tracked', label(vehicle));
        track('fitment_confirmed', { product_id: box.getAttribute('data-product-id') || '' });
      }
    });
  }

  function renderAll() {
    var vehicle = read();
    renderBars(vehicle);
    renderResultLinks(vehicle);
    renderFitment(vehicle);
  }

  function init() {
    bindBars();
    renderAll();
    document.addEventListener(EVENT, renderAll);
    global.addEventListener('storage', function (e) { if (e.key === KEY) renderAll(); });
  }

  global.FusmattenVehicle = { get: read, set: set, clear: clear, label: label, openSelector: openSelector, fitmentStatus: fitmentStatus };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})(window);
